import { createSlice } from "@reduxjs/toolkit";

// const initialState = {
//   username: null,
//   token: null,
//   firstName: null,
//   lastName: null,
//   email: null,
//   isAuthenticated: false,
// };

const initialState = {
  username: "frank",
  token: "6818a0d48051b6d7d68b6a74db82586cb7a246c250cee7a710c6813809019ce8",
  email: "frank@gmail.com",
  firstName: "",
  lastName: "",
  isAuthenticated: true,
};
const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    // REgister
    //
    // Login
    //
    setUserData(state, action) {
      return {
        ...state,
        username: action.payload.user.username,
        firstName: action.payload.user.first_name,
        lastName: action.payload.user.last_name,
        email: action.payload.user.email,
        token: action.payload.token,
        isAuthenticated: true,
      };
    },
    // Logout
    logoutUser(state, action) {
      return {
        ...state,
        username: null,
        token: null,
        firstName: null,
        lastName: null,
        email: null,
        isAuthenticated: false,
      };
    },
  },
});

export const { setUserData, logoutUser } = userSlice.actions;
export default userSlice.reducer;
